import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter023() {
  return <KbChapterPage slug="chapter-023" />;
}

(Chapter023 as unknown as { path: string }).path = "/theory-album/023";
